import assetPath from '/app/packages/entity-pages/entity-pages-news/src/assets/emptystate.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')